import { CacheService } from "@services/cache.Service";
import { IUnplannedStop } from "@tms/_models/IUnplannedStop";

export class UnplannedStopService {

    unplannedStopsServiceCache = 'unplannedStopsServiceCache';

    static $inject = ["$http", "cacheService"];

    constructor(
        private readonly $http: angular.IHttpService,
        private readonly cacheService: CacheService
    ) {
this.cacheService.createCache(this.unplannedStopsServiceCache, { maxAge: 30 * 60 * 1000 });
    }

    getUnplannedStopsForRoute(routeId: number): angular.IPromise<IUnplannedStop[]> {
        return this.$http({
            url: `/api/unplannedstops/${routeId}`,
            method: "GET"
        })
            .then((response: angular.IHttpPromiseCallbackArg<IUnplannedStop[]>) => {
                return response.data;
            });
    }

    getUnplannedStopsForRoutes(start: moment.Moment, end: moment.Moment, invalidateCache=false, unsafe=false): angular.IPromise<IUnplannedStop[]> {
        return this.cacheService.getOrRetrieveData(this.unplannedStopsServiceCache, () => this.getUnplannedStopsForRoutesFromDatabase(start, end), invalidateCache, unsafe);
    }

    getUnplannedStopsForRoutesFromDatabase(start: moment.Moment, end: moment.Moment): angular.IPromise<IUnplannedStop[]> {
        return this
            .$http({
                url: `/api/unplannedstops/plannedroutes?start=${start.toISOString()}&end=${end.toISOString()}`,
                method: "GET"
            })
            .then((response: angular.IHttpPromiseCallbackArg<IUnplannedStop[]>) => {
                return response.data;
            });
    }
}
